module.exports = __webpack_public_path__ + "img/about.5ec52150.jpg";